module.exports = __webpack_public_path__ + "img/resources.1c4d51ce.png";